// extracted by mini-css-extract-plugin
export default {"container":"certification_container__Hev-I"};